import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import img4 from '../assets/others/11102056.jpg'
import imgicon from '../assets/icons/icn-1.png'
import img1 from '../assets/course/image-1.png'
import img2 from '../assets/course/image-2.png'
import img3 from '../assets/course/image-3.png'
import img5 from '../assets/course/image-4.png'
import { Helmet } from 'react-helmet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
library.add(fas)

const Democlass = () => {
  return (
    <div> 
        <Helmet>
            <title>Free Demo Class | Takshila VLSI</title>
            <meta name="description" content="Join the VLSI demo class at Takshila VLSI in Bangalore and Hyderabad to experience hands-on learning and Check out the future of semiconductor technology." />
            <link rel="canonical" href="https://www.takshila-vlsi.com/events/demo-class/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Free Demo Class | Takshila VLSI" />
            <meta property="og:description" content="Join the VLSI demo class at Takshila VLSI in Bangalore and Hyderabad to experience hands-on learning and Check out the future of semiconductor technology." />
            <meta property="og:url" content="https://www.takshila-vlsi.com/events/demo-class/" />
            <meta property="og:site_name" content="Takshila VLSI" />
            <meta property="article:modified_time" content="2024-11-28T12:42:32+00:00" />
            <meta property="og:image" content="https://www.takshila-vlsi.com/wp-content/uploads/2018/12/shutterstock_160369865-1024x630.jpg" />
            <meta property="og:image:width" content="1024" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image:type" content="image/jpeg" />
            <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
        <Header/>
    <main>
    <section className='section-banner pg-banner p-lg-5 pt-5'>
          <div class="container text-center">
                        <div class="row justify-content-around ">
                            <div class="col-md">
                              <div class="pg-title-sec p-4 p-lg-5 bg-3 dark-bg">
                                  <h1 className='pg-title pb-3'>Free Demo Class</h1>
                                  <p className='pg-title-desc'>We provide demo class with specific tools and good classroom practice experience. This will help ensure that the students have full experience of what the course offers. The demo class categories are divided according to the course titles. Specific trainers assigned to each category. This ensures that students enjoy first-hand experience of what the class section feels like.
                                  </p>
                              </div>
                            </div>
                        </div>
          </div>
        </section>
        <section className='we-offer-section ws-section pb-5'>
            <div class="container">
                    <div class="row justify-content-start">
                        <div class="col-lg-12 text-center">
                        <h2 class="ws-section_heading txt-2 pd-03">We also offer an overview of our VLSI design courses and you will enjoy the following useful benefits during demo session.</h2>
                        </div>
                    </div>
                  
                    <div class="row justify-content-between">
                            <div class="col-lg-3">
                                <div className='icon-card mb-3 bg-10 radius-1'>
                                    <div className='icon mb-3'> <img src={imgicon} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-2'>VLSI Design Flow</div>
                                        <p>The demo classes will provide very basic information on VLSI design flow.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3">
                            <div className='icon-card bg-drk dark-bg radius-1 mb-3'>
                                    <div className='icon mb-3'> <img src={imgicon} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-2'>Semiconductor Industry</div>
                                        <p>Insight into the industry and what makes them stand out in the industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 ">
                            <div className='icon-card mb-3 bg-10 radius-1'>
                                    <div className='icon mb-3'> <img src={imgicon} alt=''/></div>
                                    <div className='icon-content'>
                                        <div className='icon-card-head mb-2'>VLSI Placement and Job Opportunities</div>
                                        <p>This demo classes will throw an insight into what job placement and job opportunities available in semiconductor industry.</p>
                                   
                                    </div>
                                </div>
                            </div>
                            
                     </div>  
            </div>
            </section>
            <section>
            <div class="coursebox-section ws-section pb-5">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-8">
                                <h2 class="ws-section_heading pd-03">Customized Training Programs</h2>
                            </div>
                            <div class="col-lg-4 align-self-center">
                                <a href='/courses'>
                                <button class="btn-primary btn-icon" href="index.html#about">View All Courses<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                            </a>
                            </div>
                        </div>

                        <div class="row align-items-center gx-xl-28 mt-5 dark-bg">
                            <div class="col-lg-6 mb-5">
                                <div class="course-box">
                                    <div class="course-box-top">
                                        <img src={img1} alt=''/>
                                    </div>
                                    <div class="course-box-btn">
                                        <a href='/product-category/vlsi-courses-for-freshers/'>know more</a>
                                    </div>
                                    <div class="course-box-bottom p-4">
                                    <h3  class="course-title mb-3">Job-oriented VLSI courses</h3>
                                    <ul class="course-item mb-3 pl-0">
                                        <li class="d-flex mb-2"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Monday – Friday 10AM to 5PM  <br/> Saturday and Sunday 10AM to 5PM </span></li>
                                        <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-user" /> <span>Divyashree | Prasanth</span></li>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-5">
                                <div class="course-box">
                                    <div class="course-box-top">
                                        <img src={img2} alt=''/>
                                    </div>
                                    <div class="course-box-btn">
                                        <a href='/product-category/vlsi-online-courses/'>know more</a>
                                    </div>
                                    <div class="course-box-bottom p-4">
                                    <h3  class="course-title mb-3">Online VLSI courses</h3>
                                    <ul class="course-item mb-3 pl-0">
                                        <li class="d-flex mb-2"> <FontAwesomeIcon icon="fa-solid fa-clock" />
                                        <span>Monday – Friday 10AM to 5PM  <br/> Saturday and Sunday 10AM to 5PM </span>
                                        </li>
                                        <li class="d-flex align-items-center mb-1"><FontAwesomeIcon icon="fa-solid fa-user" />
                                        <span>Divyashree | Prasanth</span>
                                        </li>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-5">
                                <div class="course-box">
                                    <div class="course-box-top">
                                        <img src={img3} alt=''/>
                                    </div>
                                    <div class="course-box-btn">
                                        <a href='/product-category/vlsi-courses-for-professionals/'>know more</a>
                                    </div>
                                    <div class="course-box-bottom p-4">
                                    <h3  class="course-title mb-3">Part-time VLSI courses</h3>
                                    <ul class="course-item mb-3 pl-0">
                                        <li class="d-flex mb-2"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Monday – Friday 10AM to 5PM  <br/> Saturday and Sunday 10AM to 5PM </span></li>
                                        <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-user" /> <span>Divyashree | Prasanth</span></li>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-5">
                                <div class="course-box">
                                    <div class="course-box-top">
                                        <img src={img5} alt=''/>
                                    </div>
                                    <div class="course-box-btn">
                                        <a href='/vlsi-internship/'>know more</a>
                                    </div>
                                    <div class="course-box-bottom p-4">
                                    <h3  class="course-title mb-3">VLSI Internship</h3>
                                    <ul class="course-item mb-3 pl-0">
                                        <li class="d-flex mb-2"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Monday – Friday 10AM to 5PM  <br/> Saturday and Sunday 10AM to 5PM </span></li>
                                        <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-user" /> <span>Divyashree | Prasanth</span></li>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                 </div>
            </div>
    </div>
    </section>
    <section className='p-lg-5'>
            <div class="container text-center">
              <div class="row">
                <div class="col-lg">
                <h2 class="ws-section_heading mb-3 txt-3"><span class="font-thin">Navigate your path to</span><br/> getting the dream VLSI job</h2>
                <p class="ws-section_sub-heading text-lg">Fill out the form below and avail free access to best recruiters leading the semiconductor industry</p>
                </div>
              </div>
              </div>
            </section>
            <section className='connect-section ws-section pb-5'>
            <div className='container'>
            <div class="row">
                    <div class="col-lg mr--10 mt-5">
                    <div className='ctn-frm'>
                    <h2 class="mb-3">Let's Connect</h2>
                    <iframe
                                    aria-label='Register Now'
                                    width="100%"
                                    height="850"
                                    src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                    frameborder="0" 
                                    title='Register Now'
                                   
                                />
                    </div>
                    </div>
                    <div class="col-lg img-radius mt-4">
                    <img src={img4} alt=''/>
                    </div>
                    </div>
                </div>
            </section>
        </main>
        <Enrollaction/>
        <Partnersec/> 
        <Footer/>
        </div>
  )
}

export default Democlass